var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"btn inline-s",attrs:{"disabled":_vm.disabled,"to":_vm.prevRoute}},[_vm._v("\n    Cancel\n")])}
var staticRenderFns = []

export { render, staticRenderFns }